'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var utils = require('../utils');

var index = utils.createSimpleFC({
  name: 'background',
  updateData: function updateData(ctx) {
    ctx.data.style = _objectSpread({
      overflow: 'auto',
      background: ctx.props.color || '#fff',
      minHeight: utils.deviceInfo.winHeight + (ctx.props.adjust || 0) + 'px'
    }, ctx.data.style);
    return ctx;
  }
});

exports.default = index;
